// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Status_wrap__12ujf"};